import z from 'zod/v3'

export const qualityStatuses = ['all', 'blocked', 'unblocked'] as const
export type QualityStatus = (typeof qualityStatuses)[number]

// Filtres communs aux deux onglets (lots et articles) : chaque onglet étend ce
// schéma avec ses propres filtres (n° de lot + statut, ou référence article).
export const qualitySharedSearchSchema = z.object({
  dateEndDlc: z.coerce.date().optional(),
  dateEndSold: z.coerce.date().optional(),
  dateStartDlc: z.coerce.date().optional(),
  dateStartSold: z.coerce.date().optional(),
  ean: z.string().optional(),
  label: z.string().optional(),
  page: z.number().optional(),
  pageSize: z.number().optional(),
  storeId: z.number().optional(),
})

export type QualitySharedSearch = z.infer<typeof qualitySharedSearchSchema>

/** Valeurs des filtres partagés, une fois les valeurs par défaut appliquées. */
export interface QualitySharedFilters {
  page: number
  pageSize: number
  ean: string | null
  label: string | null
  storeId: number | null
  dateStartSold?: Date
  dateEndSold?: Date
  dateStartDlc?: Date
  dateEndDlc?: Date
}

export const resolveQualitySharedFilters = (search: QualitySharedSearch): QualitySharedFilters => ({
  page: search.page ?? 0,
  pageSize: search.pageSize ?? 20,
  ean: search.ean ?? null,
  label: search.label ?? null,
  storeId: search.storeId ?? null,
  dateStartSold: search.dateStartSold,
  dateEndSold: search.dateEndSold,
  dateStartDlc: search.dateStartDlc,
  dateEndDlc: search.dateEndDlc,
})

/** Filtres partagés remis sous forme de search params (changement d'onglet). */
export const toQualitySharedSearch = (filters: QualitySharedFilters): QualitySharedSearch => ({
  page: filters.page,
  pageSize: filters.pageSize,
  ean: filters.ean ?? undefined,
  label: filters.label ?? undefined,
  storeId: filters.storeId ?? undefined,
  dateStartSold: filters.dateStartSold,
  dateEndSold: filters.dateEndSold,
  dateStartDlc: filters.dateStartDlc,
  dateEndDlc: filters.dateEndDlc,
})

/** Partie commune de la query envoyée aux endpoints lots et articles. */
export const buildQualitySharedQuery = (filters: QualitySharedFilters) => ({
  page: filters.page + 1, // X-data-grid starts at 0 but lucid starts at 1
  pageSize: filters.pageSize,
  ean: filters.ean ?? undefined,
  label: filters.label ?? undefined,
  store: filters.storeId ?? undefined,
  dateStartSold: filters.dateStartSold?.toISOString(),
  dateEndSold: filters.dateEndSold?.toISOString(),
  dateStartDlc: filters.dateStartDlc?.toISOString(),
  dateEndDlc: filters.dateEndDlc?.toISOString(),
})
